import { Box, Link } from '@mui/material';
import PbaBowlsMasterLogo from '../../resources/assets/images/pba-bowls-master-logo.png';

const PoweredByBowlsMaster = ({ width }) => (
  <Box display="flex">
    <Link href="https://bowlsmaster.co.za" target="_blank" rel="noopener noreferrer">
      <img
        src={PbaBowlsMasterLogo}
        alt="PBA Bowls Master"
        style={{ width: width || '180px', height: 'auto' }}
      />
    </Link>
  </Box>
);

export default PoweredByBowlsMaster;
